import { render, staticRenderFns } from "./Progress.page.vue?vue&type=template&id=398bb1b0&scoped=true"
import script from "./Progress.page.vue?vue&type=script&lang=js"
export * from "./Progress.page.vue?vue&type=script&lang=js"
import style0 from "./Progress.page.vue?vue&type=style&index=0&id=398bb1b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398bb1b0",
  null
  
)

export default component.exports